import { HeaderUiConstantsMobileMenuItem, MenuLinksMainItem } from '@/types/constants/types';
import {
  HeaderUiConstantsMobileMenuOptionsMainMenu,
  HeaderUiConstantsMobileMenuOptionsBrowseMenu,
  HeaderUiConstantsMobileMenuOptionsDashboardMenu,
} from '@/types/constants/enums';
import { TFunction } from 'i18next';
import translationFallback from '../../utilites/translations/translationFallback';
import clsx from 'clsx';
import stylesConstants from '@/constants/styles.constants';
import uiItems from '@/constants/ui-items/index.constants';
import { MobileMenuDashboardClasses } from '@/types/props/components';
import { ItemTranslation } from '@/types/common';
import { THeader } from '@/types/translations/types';
import translationfallbackTyped from '../../utilites/translations/translationfallbackTyped';
import MenuItem from '@/components/header/Menu/MenuItem';

export function getMobileMenuItemText(item: ItemTranslation, tHeader: THeader) {
  if (item.translate === true) {
    const { tKey, tFallback } = item;
    const itemText = translationfallbackTyped(tKey, tHeader, tFallback);
    return itemText;
  }
  return item.tKey;
}

export function getAuthButtonClass(actionType: 'login' | 'signup') {
  return clsx(stylesConstants.header.mobileMenu.defaultButtonClassAuth, {
    'tw-bg-[#1c5ceb] tw-text-white': actionType === 'signup',
    'tw-text-[#1c5ceb] tw-border-solid tw-border-[#1c5ceb] tw-border-2': actionType === 'login',
  });
}

export function getHeaderUiConstantsMobileMenuMainMenuClasses(
  mainMenuState: HeaderUiConstantsMobileMenuOptionsMainMenu
) {
  return clsx(stylesConstants.header.mobileMenu.defaultUlClass, {
    [stylesConstants.header.mobileMenu.defaultHiddenUlClass]: mainMenuState !== 'main',
  });
}

function getHeaderUiConstantsMobileMenuBrowseMenuClasses(
  mainMenuState: HeaderUiConstantsMobileMenuOptionsMainMenu,
  browseMenuState: HeaderUiConstantsMobileMenuOptionsBrowseMenu
) {
  const browseMenuClasses = clsx(stylesConstants.header.mobileMenu.defaultUlClass, {
    [stylesConstants.header.mobileMenu.defaultHiddenUlClass]:
      mainMenuState !== 'browse' || browseMenuState !== 'browseMain',
  });

  const browseMenuStatusClasses = clsx(stylesConstants.header.mobileMenu.defaultUlClass, {
    [stylesConstants.header.mobileMenu.defaultHiddenUlClass]:
      mainMenuState !== 'browse' || browseMenuState !== 'status',
  });

  const browseMenuBrandClasses = clsx(stylesConstants.header.mobileMenu.defaultUlClass, {
    [stylesConstants.header.mobileMenu.defaultHiddenUlClass]:
      mainMenuState !== 'browse' || browseMenuState !== 'brand',
  });

  const browseMenuCountriesClasses = clsx(stylesConstants.header.mobileMenu.defaultUlClass, {
    [stylesConstants.header.mobileMenu.defaultHiddenUlClass]:
      mainMenuState !== 'browse' || browseMenuState !== 'countries',
  });

  const browseMenuTopicsClasses = clsx(stylesConstants.header.mobileMenu.defaultUlClass, {
    [stylesConstants.header.mobileMenu.defaultHiddenUlClass]:
      mainMenuState !== 'browse' || browseMenuState !== 'topics',
  });

  return {
    browseMenuClasses,
    browseMenuStatusClasses,
    browseMenuBrandClasses,
    browseMenuCountriesClasses,
    browseMenuTopicsClasses,
  };
}

export function getHeaderUiConstantsMobileMenuDashboardMenuClasses(
  mainMenuState: HeaderUiConstantsMobileMenuOptionsMainMenu,
  dashboardMenuState: HeaderUiConstantsMobileMenuOptionsDashboardMenu
) {
  const dashboardMenuClasses = clsx(stylesConstants.header.mobileMenu.defaultUlClass, {
    [stylesConstants.header.mobileMenu.defaultHiddenUlClass]:
      mainMenuState !== 'dashboard' || dashboardMenuState !== 'dashboardMain',
  });

  const dashboardMenuSettingsClasses = clsx(stylesConstants.header.mobileMenu.defaultUlClass, {
    [stylesConstants.header.mobileMenu.defaultHiddenUlClass]:
      mainMenuState !== 'dashboard' || dashboardMenuState !== 'settings',
  });

  const dashboardMenuLanguageClasses = clsx(stylesConstants.header.mobileMenu.defaultUlClass, {
    [stylesConstants.header.mobileMenu.defaultHiddenUlClass]:
      mainMenuState !== 'dashboard' || dashboardMenuState !== 'language',
  });

  return {
    dashboardMenuClasses,
    dashboardMenuSettingsClasses,
    dashboardMenuLanguageClasses,
  };
}

export function getHeaderUiConstantsMobileMenuSellMenuClasses(
  mainMenuState: HeaderUiConstantsMobileMenuOptionsMainMenu
) {
  const sellMenuClasses = clsx(stylesConstants.header.mobileMenu.defaultUlClass, {
    [stylesConstants.header.mobileMenu.defaultHiddenUlClass]: mainMenuState !== 'sell',
  });

  return {
    sellMenuClasses,
  };
}

export function getHeaderUiConstantsMobileMenuAboutMenuClasses(
  mainMenuState: HeaderUiConstantsMobileMenuOptionsMainMenu
) {
  const aboutMenuClasses = clsx(stylesConstants.header.mobileMenu.defaultUlClass, {
    [stylesConstants.header.mobileMenu.defaultHiddenUlClass]: mainMenuState !== 'about',
  });

  return {
    aboutMenuClasses,
  };
}

export function getMobileMenuBrowseItems(
  browseMenuState: HeaderUiConstantsMobileMenuOptionsBrowseMenu,
  mainMenuState: HeaderUiConstantsMobileMenuOptionsMainMenu
) {
  const browseMenuClasses = getHeaderUiConstantsMobileMenuBrowseMenuClasses(
    mainMenuState,
    browseMenuState
  );
  return [
    {
      key: 'browse',
      className: browseMenuClasses.browseMenuClasses,
      items: uiItems.header.mobileMenu.browseMenu.browse,
    },
    {
      key: 'browse-status',
      className: browseMenuClasses.browseMenuStatusClasses,
      items: uiItems.header.mobileMenu.browseMenu.browseMenuStatus,
    },
    {
      key: 'browse-brand',
      className: browseMenuClasses.browseMenuBrandClasses,
      items: uiItems.header.mobileMenu.browseMenu.browseMenuBrand,
    },
    {
      key: 'browse-countries',
      className: browseMenuClasses.browseMenuCountriesClasses,
      items: uiItems.header.mobileMenu.browseMenu.browseMenuCountries,
    },
    {
      key: 'browse-topics',
      className: browseMenuClasses.browseMenuTopicsClasses,
      items: uiItems.header.mobileMenu.browseMenu.browseMenuTopics,
    },
  ];
}

export function getMobileMenuDashboardItems(
  dashboardMenuClasses: MobileMenuDashboardClasses,
  buyerNotificationsCallToAc: number,
  sellerNotificationsCallToAc: number,
  totalNoti: number
) {
  return [
    {
      key: 'dashboard',
      className: dashboardMenuClasses.dashboardMenuClasses,
      items: uiItems.header.mobileMenu.dashboardMenu.dashboard(
        buyerNotificationsCallToAc,
        sellerNotificationsCallToAc,
        totalNoti
      ),
    },
    {
      key: 'dashboard-settings',
      className: dashboardMenuClasses.dashboardMenuSettingsClasses,
      items: uiItems.header.mobileMenu.dashboardMenu.dashboardMenuSettings,
    },
  ];
}

export function generateMenuItemComponent(
  item: MenuLinksMainItem,
  index: number,
  t: TFunction,
  pathname: string
) {
  const { tKey, tFallback, ...otherProps } = item;
  const MenuProps = {
    ...otherProps,
    mainText: translationFallback(tKey, t(tKey), tFallback),
    pathname,
  };
  return (
    <MenuItem {...MenuProps} key={`menu-item-${index}-${otherProps.badgeCount}-${tFallback}`} />
  );
}
